export const formatString = (str: string, replaceStrArray: string[]) => {
  const finalStr = replaceStrArray?.reduce(
    (acc, replaceStr, index) => acc?.replace(`{${index}}`, replaceStr),
    str,
  );
  return finalStr;
};
